import React from 'react'

import { PingPongButtonTypeEnum } from '../../../utils/ping-pong-button-type.enum.ts'

export enum AdminActionEnum {
  SKIP_DEPOSIT_PAYMENT = 'SKIP_DEPOSIT_PAYMENT',
  SKIP_BALANCE_PAYMENT = 'SKIP_BALANCE_PAYMENT',
  CANCEL_ADJUSTMENTS_CONFIRMATION = 'CANCEL_ADJUSTMENTS_CONFIRMATION',
  CONFIRM_POST_BALANCE_ADJUSTMENTS = 'CONFIRM_POST_BALANCE_ADJUSTMENTS',
  CANCEL_USER_CONFIRMED_BOOKING = 'CANCEL_USER_CONFIRMED_BOOKING',
  CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION = 'CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION',
  SKIP_ADJUSTMENTS = 'SKIP_ADJUSTMENTS',
}

export const getLabelAdminActionModal = ({
  adminAction,
}: {
  adminAction: AdminActionEnum
}) => {
  switch (adminAction) {
    case AdminActionEnum.CANCEL_ADJUSTMENTS_CONFIRMATION:
      return 'Confirmer le retour à l’étape des ajustements des prestations'
    case AdminActionEnum.CANCEL_USER_CONFIRMED_BOOKING:
      return "Confirmer le retour à l'étape de la confirmation de la réservation"
    case AdminActionEnum.SKIP_DEPOSIT_PAYMENT:
    case AdminActionEnum.SKIP_BALANCE_PAYMENT:
      return 'Confirmer le passage à l’étape suivante sans paiement'
    case AdminActionEnum.CONFIRM_POST_BALANCE_ADJUSTMENTS:
      return 'Confirmer le passage à l’étape du solde post séjour'
    case AdminActionEnum.CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION:
      return 'Confirmer le retour à l’étape du départ en séminaire'
    case AdminActionEnum.SKIP_ADJUSTMENTS:
      return 'Confirmer le passage à l’étape suivante sans ajustement'
  }
}

export const getContentAdminActionModal = ({
  adminAction,
}: {
  adminAction: AdminActionEnum
}) => {
  switch (adminAction) {
    case AdminActionEnum.CANCEL_ADJUSTMENTS_CONFIRMATION:
      return (
        <>
          <div>
            En confirmant ci-dessous, vous annulez la confirmation des
            ajustements par le client pour retourner à l’étape précédente.
          </div>

          <div className='font-medium'>
            Attention : le client sera invité à confirmer à nouveau les
            ajustements.
          </div>

          <div>
            Cette action est définitive et ne permet aucun retour en arrière
            manuel. Nous vous invitons à vérifier que le client est prêt à
            reconfirmer les ajustements.
          </div>
        </>
      )
    case AdminActionEnum.CANCEL_USER_CONFIRMED_BOOKING:
      return (
        <>
          <div>
            En confirmant ci-dessous, vous annulez la confirmation de la
            réservation par le client
          </div>

          <div className='font-medium'>
            Attention : le client sera invité à confirmer à nouveau sa
            réservation.
          </div>

          <div>
            Nous vous invitons à vérifier que le client est prêt à reconfirmer
            sa réservation.
          </div>
        </>
      )
    case AdminActionEnum.SKIP_DEPOSIT_PAYMENT:
      return (
        <>
          <div>
            En confirmant ci-dessous, le client aura accès à l’étape de
            l’ajustement des prestations. Il sera en mesure de voir et de
            confirmer les ajustements effectués par le CSM sur la réservation
            sans avoir effectué le paiement de l&apos;acompte
          </div>
          <div>
            Cette étape est définitive et ne permet aucun retour en arrière
            manuel. Nous vous invitons à vérifier que vous êtes prêt à proposer
            des ajustements de prestation au client avant de confirmer
            ci-dessous.
          </div>
        </>
      )
    case AdminActionEnum.SKIP_BALANCE_PAYMENT:
      return (
        <>
          <div>
            En confirmant ci-dessous, le client aura accès à l’étape de
            préparation au départ en séjour. Il sera en mesure de voir les
            coordonnées complètes du lieu et de l’hôte.
          </div>
          <div>
            Cette étape est définitive et ne permet aucun retour en arrière
            manuel. Nous vous invitons à vérifier que vous êtes prêt à mettre en
            relation le client avec l’hôte avant de confirmer ci-dessous.
          </div>
        </>
      )
    case AdminActionEnum.CONFIRM_POST_BALANCE_ADJUSTMENTS:
      return (
        <>
          <div>
            En confirmant ci-dessous, le client sera invité à régler le solde
            post séjour si de nouveaux ajustements de prestations ont été
            réalisés.
          </div>
          <div>
            Cette étape est définitive et ne permet aucun retour en arrière
            manuel. Nous vous invitons à vérifier que tous les ajustements ont
            été réalisés avant de confirmer ci-dessous.
          </div>
          <div>
            Si aucun ajustement n’a été réalisé, le client sera invité à
            télécharger les documents relatifs au séjour et donner son avis.
          </div>
        </>
      )
    case AdminActionEnum.CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION:
      return (
        <>
          <div>
            En confirmant ci-dessous, vous annulez la confirmation des
            ajustements post-séjour pour retourner à l’étape précédente.
          </div>
          <div>
            Cette action est définitive et ne permet aucun retour en arrière
            manuel. Nous vous invitons à vérifier que le client est prêt à
            reconfirmer les ajustements.
          </div>
        </>
      )
    case AdminActionEnum.SKIP_ADJUSTMENTS:
      return (
        <>
          <div>
            En confirmant ci-dessous, le client sera invité à régler le solde du
            séjour.
          </div>
          <div>
            Assurez-vous que le client est prêt à régler le solde du séjour sans
            ajustement de prestations.
          </div>
        </>
      )
  }
}

export const getLabelAdminActionButton = ({
  adminAction,
}: {
  adminAction: AdminActionEnum
}) => {
  switch (adminAction) {
    case AdminActionEnum.CANCEL_ADJUSTMENTS_CONFIRMATION:
    case AdminActionEnum.CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION:
    case AdminActionEnum.CANCEL_USER_CONFIRMED_BOOKING:
      return "Admin | Annuler et revenir à l'étape précédente"
    case AdminActionEnum.SKIP_DEPOSIT_PAYMENT:
    case AdminActionEnum.SKIP_BALANCE_PAYMENT:
      return "Admin | Passer à l'étape suivante sans paiement"
    case AdminActionEnum.CONFIRM_POST_BALANCE_ADJUSTMENTS:
      return "Admin | Passer à l'étape suivante"
    case AdminActionEnum.SKIP_ADJUSTMENTS:
      return "Admin | Passer à l'étape suivante sans ajustement"
  }
}

export const getTypeAdminActionButton = ({
  adminAction,
}: {
  adminAction: AdminActionEnum
}) => {
  switch (adminAction) {
    case AdminActionEnum.CANCEL_ADJUSTMENTS_CONFIRMATION:
      return PingPongButtonTypeEnum.ADMIN_PREVIOUS_STEP
    case AdminActionEnum.SKIP_DEPOSIT_PAYMENT:
    case AdminActionEnum.SKIP_BALANCE_PAYMENT:
      return PingPongButtonTypeEnum.SUPER_ADMIN_NEXT_STEP
    case AdminActionEnum.CONFIRM_POST_BALANCE_ADJUSTMENTS:
    case AdminActionEnum.SKIP_ADJUSTMENTS:
      return PingPongButtonTypeEnum.ADMIN_NEXT_STEP
    case AdminActionEnum.CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION:
    case AdminActionEnum.CANCEL_USER_CONFIRMED_BOOKING:
      return PingPongButtonTypeEnum.SUPER_ADMIN_PREVIOUS_STEP
  }
}
